<svg
  *ngIf="name === 'home-smile'"
  xmlns="http://www.w3.org/2000/svg"
  width="21"
  height="21"
  viewBox="0 0 21 21"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2.93657 7.28783C2.50391 8.07828 2.50391 9.03179 2.50391 10.9388V12.2063C2.50391 15.4571 2.50391 17.0825 3.48022 18.0923C4.45653 19.1022 6.02788 19.1022 9.17057 19.1022H12.5039C15.6466 19.1022 17.218 19.1022 18.1943 18.0923C19.1706 17.0825 19.1706 15.4571 19.1706 12.2063V10.9388C19.1706 9.03179 19.1706 8.07828 18.7379 7.28783C18.3052 6.49739 17.5148 6.00681 15.9339 5.02565L14.2672 3.99127C12.5961 2.95412 11.7605 2.43555 10.8372 2.43555C9.91396 2.43555 9.0784 2.95412 7.40727 3.99127L5.7406 5.02565C4.15969 6.00681 3.36924 6.49739 2.93657 7.28783ZM8.70942 13.6001C8.43211 13.3946 8.04068 13.4527 7.83513 13.73C7.62959 14.0073 7.68776 14.3988 7.96506 14.6043C8.7754 15.205 9.76643 15.5605 10.8372 15.5605C11.9081 15.5605 12.8991 15.205 13.7094 14.6043C13.9867 14.3988 14.0449 14.0073 13.8393 13.73C13.6338 13.4527 13.2424 13.3946 12.9651 13.6001C12.3581 14.05 11.6255 14.3105 10.8372 14.3105C10.049 14.3105 9.31637 14.05 8.70942 13.6001Z"
    fill="currentColor"
  />
</svg>

<svg
  *ngIf="name === 'building'"
  xmlns="http://www.w3.org/2000/svg"
  width="21"
  height="21"
  viewBox="0 0 21 21"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M18.543 7.85221C18.543 6.68183 18.543 6.09664 18.2621 5.67626C18.1405 5.49428 17.9842 5.33803 17.8023 5.21643C17.4346 4.97075 16.9408 4.93996 16.0396 4.9361C16.043 5.17893 16.043 5.43267 16.043 5.69431L16.043 5.76888V6.81055H16.8763C17.2215 6.81055 17.5013 7.09037 17.5013 7.43555C17.5013 7.78072 17.2215 8.06055 16.8763 8.06055H16.043V9.31055H16.8763C17.2215 9.31055 17.5013 9.59037 17.5013 9.93555C17.5013 10.2807 17.2215 10.5605 16.8763 10.5605H16.043V11.8105H16.8763C17.2215 11.8105 17.5013 12.0904 17.5013 12.4355C17.5013 12.7807 17.2215 13.0605 16.8763 13.0605H16.043V18.4772H14.793V5.76888C14.793 4.19753 14.793 3.41186 14.3048 2.9237C13.8167 2.43555 13.031 2.43555 11.4596 2.43555H9.79297C8.22162 2.43555 7.43595 2.43555 6.94779 2.9237C6.45964 3.41186 6.45964 4.19753 6.45964 5.76888V18.4772H5.20964V13.0605H4.3763C4.03112 13.0605 3.7513 12.7807 3.7513 12.4355C3.7513 12.0904 4.03112 11.8105 4.3763 11.8105H5.20964V10.5605H4.3763C4.03112 10.5605 3.7513 10.2807 3.7513 9.93555C3.7513 9.59037 4.03112 9.31055 4.3763 9.31055H5.20964V8.06055H4.3763C4.03112 8.06055 3.7513 7.78072 3.7513 7.43555C3.7513 7.09037 4.03112 6.81055 4.3763 6.81055H5.20964V5.76888L5.20963 5.6943C5.2096 5.43267 5.20957 5.17893 5.21299 4.9361C4.31182 4.93996 3.81804 4.97075 3.45035 5.21643C3.26837 5.33803 3.11212 5.49428 2.99052 5.67626C2.70964 6.09664 2.70964 6.68183 2.70964 7.85221V18.4772H2.29297C1.94779 18.4772 1.66797 18.757 1.66797 19.1022C1.66797 19.4474 1.94779 19.7272 2.29297 19.7272H18.9596C19.3048 19.7272 19.5846 19.4474 19.5846 19.1022C19.5846 18.757 19.3048 18.4772 18.9596 18.4772H18.543V7.85221ZM8.33464 10.5605C8.33464 10.2154 8.61446 9.93555 8.95964 9.93555H12.293C12.6381 9.93555 12.918 10.2154 12.918 10.5605C12.918 10.9057 12.6381 11.1855 12.293 11.1855H8.95964C8.61446 11.1855 8.33464 10.9057 8.33464 10.5605ZM8.33464 13.0605C8.33464 12.7154 8.61446 12.4355 8.95964 12.4355H12.293C12.6381 12.4355 12.918 12.7154 12.918 13.0605C12.918 13.4057 12.6381 13.6855 12.293 13.6855H8.95964C8.61446 13.6855 8.33464 13.4057 8.33464 13.0605ZM10.6263 15.9772C10.9715 15.9772 11.2513 16.257 11.2513 16.6022V18.4772H10.0013V16.6022C10.0013 16.257 10.2811 15.9772 10.6263 15.9772ZM8.33464 5.97721C8.33464 5.63204 8.61446 5.35221 8.95964 5.35221H12.293C12.6381 5.35221 12.918 5.63204 12.918 5.97721C12.918 6.32239 12.6381 6.60221 12.293 6.60221H8.95964C8.61446 6.60221 8.33464 6.32239 8.33464 5.97721ZM8.33464 8.47721C8.33464 8.13204 8.61446 7.85221 8.95964 7.85221H12.293C12.6381 7.85221 12.918 8.13204 12.918 8.47721C12.918 8.82239 12.6381 9.10221 12.293 9.10221H8.95964C8.61446 9.10221 8.33464 8.82239 8.33464 8.47721Z"
    fill="currentColor"
  />
</svg>

<svg
  *ngIf="name === 'plate'"
  xmlns="http://www.w3.org/2000/svg"
  width="21"
  height="21"
  viewBox="0 0 21 21"
  fill="none"
>
  <path
    d="M11.4622 3.26953C11.4622 2.92435 11.1824 2.64453 10.8372 2.64453C10.4921 2.64453 10.2122 2.92435 10.2122 3.26953V4.9362C10.2122 5.28138 10.4921 5.5612 10.8372 5.5612C11.1824 5.5612 11.4622 5.28138 11.4622 4.9362V3.26953Z"
    fill="currentColor"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M19.7956 10.8166C19.7956 12.3481 19.7956 13.5611 19.668 14.5105C19.5366 15.4875 19.2598 16.2783 18.6362 16.9019C18.0126 17.5255 17.2218 17.8023 16.2448 17.9337C15.2954 18.0613 14.0824 18.0613 12.551 18.0613H9.12347C7.59205 18.0613 6.37905 18.0613 5.42972 17.9337C4.4527 17.8023 3.66191 17.5255 3.03828 16.9019C2.41464 16.2783 2.13788 15.4875 2.00652 14.5105C1.87888 13.5611 1.87889 12.3481 1.87891 10.8166L1.87891 10.5799C1.87892 10.3969 1.87899 10.2186 1.87935 10.0447C1.88001 9.72504 1.88163 9.42071 1.88562 9.13116C1.89684 8.31848 1.92675 7.62217 2.00652 7.02883C2.13788 6.05181 2.41464 5.26102 3.03828 4.63738C3.66191 4.01375 4.4527 3.73698 5.42972 3.60563C6.02675 3.52536 6.72807 3.49557 7.54729 3.48452C7.68499 3.48267 7.89948 3.4813 8.12773 3.4803C8.58841 3.47828 8.96224 3.85181 8.96224 4.31249V4.93627C8.96224 5.9718 9.80171 6.81127 10.8372 6.81127C11.8728 6.81127 12.7122 5.9718 12.7122 4.93627V4.31143C12.7122 3.85116 13.0856 3.47732 13.5458 3.4795C14.6198 3.48458 15.5111 3.50698 16.2448 3.60563C17.2218 3.73698 18.0126 4.01375 18.6362 4.63738C19.2598 5.26102 19.5366 6.05181 19.668 7.02883C19.7956 7.97817 19.7956 9.19114 19.7956 10.7226V10.8166ZM7.50391 8.8946C7.15873 8.8946 6.87891 9.17442 6.87891 9.5196C6.87891 9.86478 7.15873 10.1446 7.50391 10.1446H14.1706C14.5158 10.1446 14.7956 9.86478 14.7956 9.5196C14.7956 9.17442 14.5158 8.8946 14.1706 8.8946H7.50391ZM7.50391 11.8113C7.15873 11.8113 6.87891 12.0911 6.87891 12.4363C6.87891 12.7814 7.15873 13.0613 7.50391 13.0613H12.0872C12.4324 13.0613 12.7122 12.7814 12.7122 12.4363C12.7122 12.0911 12.4324 11.8113 12.0872 11.8113H7.50391Z"
    fill="currentColor"
  />
</svg>

<svg
  *ngIf="name === 'clipboard'"
  xmlns="http://www.w3.org/2000/svg"
  width="21"
  height="21"
  viewBox="0 0 21 21"
  fill="none"
>
  <path
    d="M7.5026 3.68555C7.5026 2.99519 8.06225 2.43555 8.7526 2.43555H12.9193C13.6096 2.43555 14.1693 2.99519 14.1693 3.68555V4.51888C14.1693 5.20924 13.6096 5.76888 12.9193 5.76888H8.7526C8.06225 5.76888 7.5026 5.20924 7.5026 4.51888V3.68555Z"
    fill="currentColor"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.2526 4.13273C5.20435 4.19154 4.54259 4.35858 4.06817 4.833C3.33594 5.56523 3.33594 6.74374 3.33594 9.10077V14.1008C3.33594 16.4578 3.33594 17.6363 4.06817 18.3685C4.8004 19.1008 5.97891 19.1008 8.33594 19.1008H13.3359C15.693 19.1008 16.8715 19.1008 17.6037 18.3685C18.3359 17.6363 18.3359 16.4578 18.3359 14.1008V9.10077C18.3359 6.74374 18.3359 5.56523 17.6037 4.833C17.1293 4.35858 16.4675 4.19154 15.4193 4.13273V4.51888C15.4193 5.89959 14.3 7.01888 12.9193 7.01888H8.7526C7.37189 7.01888 6.2526 5.89959 6.2526 4.51888V4.13273ZM6.04427 9.51888C6.04427 9.1737 6.32409 8.89388 6.66927 8.89388H15.0026C15.3478 8.89388 15.6276 9.1737 15.6276 9.51888C15.6276 9.86406 15.3478 10.1439 15.0026 10.1439H6.66927C6.32409 10.1439 6.04427 9.86406 6.04427 9.51888ZM6.8776 12.4355C6.8776 12.0904 7.15743 11.8105 7.5026 11.8105H14.1693C14.5144 11.8105 14.7943 12.0904 14.7943 12.4355C14.7943 12.7807 14.5144 13.0605 14.1693 13.0605H7.5026C7.15743 13.0605 6.8776 12.7807 6.8776 12.4355ZM7.71094 15.3522C7.71094 15.007 7.99076 14.7272 8.33594 14.7272H13.3359C13.6811 14.7272 13.9609 15.007 13.9609 15.3522C13.9609 15.6974 13.6811 15.9772 13.3359 15.9772H8.33594C7.99076 15.9772 7.71094 15.6974 7.71094 15.3522Z"
    fill="currentColor"
  />
</svg>

<svg
  *ngIf="name === 'chart'"
  xmlns="http://www.w3.org/2000/svg"
  width="21"
  height="21"
  viewBox="0 0 21 21"
  fill="none"
>
  <path
    d="M17.5013 12.2272C17.5013 11.882 17.2215 11.6022 16.8763 11.6022H14.3763C14.0311 11.6022 13.7513 11.882 13.7513 12.2272V17.8522H12.5013V4.31055C12.5013 3.70362 12.5 3.3113 12.4611 3.02224C12.4247 2.75115 12.3658 2.66618 12.3182 2.61861C12.2707 2.57103 12.1857 2.51218 11.9146 2.47574C11.6255 2.43687 11.2332 2.43555 10.6263 2.43555C10.0194 2.43555 9.62706 2.43687 9.33799 2.47574C9.0669 2.51218 8.98194 2.57103 8.93436 2.61861C8.88678 2.66618 8.82794 2.75115 8.79149 3.02224C8.75263 3.3113 8.7513 3.70362 8.7513 4.31055V17.8522H7.5013V8.06055C7.5013 7.71537 7.22148 7.43555 6.8763 7.43555H4.3763C4.03112 7.43555 3.7513 7.71537 3.7513 8.06055V17.8522H2.5013H2.29297C1.94779 17.8522 1.66797 18.132 1.66797 18.4772C1.66797 18.8224 1.94779 19.1022 2.29297 19.1022H18.9596C19.3048 19.1022 19.5846 18.8224 19.5846 18.4772C19.5846 18.132 19.3048 17.8522 18.9596 17.8522H18.7513H17.5013V12.2272Z"
    fill="currentColor"
  />
</svg>

<svg
  *ngIf="name === 'users-group'"
  xmlns="http://www.w3.org/2000/svg"
  width="21"
  height="21"
  viewBox="0 0 21 21"
  fill="none"
>
  <path
    d="M13.7513 7.02018C13.7513 8.63101 12.4455 9.93685 10.8346 9.93685C9.2238 9.93685 7.91797 8.63101 7.91797 7.02018C7.91797 5.40935 9.2238 4.10352 10.8346 4.10352C12.4455 4.10352 13.7513 5.40935 13.7513 7.02018Z"
    fill="currentColor"
  />
  <path
    d="M15.8359 14.5202C15.8359 16.131 13.5974 17.4368 10.8359 17.4368C8.07451 17.4368 5.83594 16.131 5.83594 14.5202C5.83594 12.9094 8.07451 11.6035 10.8359 11.6035C13.5974 11.6035 15.8359 12.9094 15.8359 14.5202Z"
    fill="currentColor"
  />
  <path
    d="M6.77228 4.93555C6.92017 4.93555 7.06454 4.95006 7.20395 4.97768C6.86432 5.58093 6.67057 6.27728 6.67057 7.01888C6.67057 7.74243 6.855 8.4229 7.1794 9.01585C7.04761 9.0404 6.9115 9.05327 6.77228 9.05327C5.5936 9.05327 4.63809 8.13148 4.63809 6.99441C4.63809 5.85733 5.5936 4.93555 6.77228 4.93555Z"
    fill="currentColor"
  />
  <path
    d="M5.37669 16.5905C4.90342 16.0248 4.58724 15.3306 4.58724 14.5189C4.58724 13.732 4.88438 13.0555 5.33372 12.4995C3.74649 12.6226 2.50391 13.4907 2.50391 14.5434C2.50391 15.6059 3.76833 16.4804 5.37669 16.5905Z"
    fill="currentColor"
  />
  <path
    d="M15.0021 7.01888C15.0021 7.74243 14.8177 8.4229 14.4933 9.01585C14.6251 9.04041 14.7612 9.05327 14.9004 9.05327C16.0791 9.05327 17.0346 8.13148 17.0346 6.99441C17.0346 5.85733 16.0791 4.93555 14.9004 4.93555C14.7525 4.93555 14.6082 4.95006 14.4688 4.97768C14.8084 5.58093 15.0021 6.27728 15.0021 7.01888Z"
    fill="currentColor"
  />
  <path
    d="M16.296 16.5905C17.9044 16.4804 19.1688 15.6059 19.1688 14.5434C19.1688 13.4907 17.9262 12.6226 16.339 12.4995C16.7883 13.0555 17.0855 13.732 17.0855 14.5189C17.0855 15.3306 16.7693 16.0248 16.296 16.5905Z"
    fill="currentColor"
  />
</svg>

<svg
  *ngIf="name === 'pie-chart'"
  xmlns="http://www.w3.org/2000/svg"
  width="21"
  height="21"
  viewBox="0 0 21 21"
  fill="none"
>
  <path
    d="M6.02231 4.10431C6.39278 3.85676 6.78177 3.64207 7.18482 3.46157C8.32805 2.94959 8.89967 2.6936 9.66012 3.18627C10.4206 3.67894 10.4206 4.48711 10.4206 6.10344V7.35344C10.4206 8.92479 10.4206 9.71046 10.9087 10.1986C11.3969 10.6868 12.1826 10.6868 13.7539 10.6868H15.0039C16.6202 10.6868 17.4284 10.6868 17.9211 11.4472C18.4137 12.2077 18.1578 12.7793 17.6458 13.9225C17.4653 14.3256 17.2506 14.7146 17.003 15.085C16.1331 16.3869 14.8967 17.4016 13.4502 18.0008C12.0036 18.6 10.4118 18.7568 8.87611 18.4513C7.34043 18.1459 5.92981 17.3919 4.82265 16.2847C3.71548 15.1775 2.96149 13.7669 2.65603 12.2312C2.35056 10.6956 2.50734 9.10378 3.10653 7.65719C3.70572 6.21061 4.72042 4.9742 6.02231 4.10431Z"
    fill="currentColor"
  />
  <path
    d="M18.7089 6.16053C18.0324 4.44329 16.6637 3.07452 14.9464 2.39801C13.6618 1.89194 12.5039 3.05566 12.5039 4.43637V7.76971C12.5039 8.22994 12.877 8.60304 13.3372 8.60304H16.6706C18.0513 8.60304 19.215 7.44516 18.7089 6.16053Z"
    fill="currentColor"
  />
</svg>

<svg
  *ngIf="name === 'dialog'"
  xmlns="http://www.w3.org/2000/svg"
  width="21"
  height="21"
  viewBox="0 0 21 21"
  fill="none"
>
  <path
    d="M19.1706 7.85221C19.1706 4.86067 16.7455 2.43555 13.7539 2.43555C12.0182 2.43555 10.4731 3.25413 9.48183 4.52489C13.7098 4.68835 17.0872 8.16753 17.0872 12.4355C17.0872 12.5275 17.0857 12.619 17.0826 12.7102L17.3594 12.7843C18.1647 12.9998 18.9014 12.263 18.686 11.4578L18.5798 11.0611C18.4941 10.7406 18.5456 10.4021 18.6835 10.1003C18.9963 9.41554 19.1706 8.65423 19.1706 7.85221Z"
    fill="currentColor"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M15.8372 12.4355C15.8372 16.1174 12.8525 19.1022 9.17057 19.1022C8.14099 19.1022 7.16591 18.8688 6.29537 18.452C5.99616 18.3088 5.65718 18.2585 5.33673 18.3443L4.31503 18.6176C3.50975 18.8331 2.77303 18.0964 2.9885 17.2911L3.26187 16.2694C3.34761 15.9489 3.29732 15.61 3.15407 15.3108C2.7373 14.4402 2.50391 13.4651 2.50391 12.4355C2.50391 8.75365 5.48867 5.76888 9.17057 5.76888C12.8525 5.76888 15.8372 8.75365 15.8372 12.4355ZM6.25391 13.2689C6.71414 13.2689 7.08724 12.8958 7.08724 12.4355C7.08724 11.9753 6.71414 11.6022 6.25391 11.6022C5.79367 11.6022 5.42057 11.9753 5.42057 12.4355C5.42057 12.8958 5.79367 13.2689 6.25391 13.2689ZM9.17057 13.2689C9.63081 13.2689 10.0039 12.8958 10.0039 12.4355C10.0039 11.9753 9.63081 11.6022 9.17057 11.6022C8.71034 11.6022 8.33724 11.9753 8.33724 12.4355C8.33724 12.8958 8.71034 13.2689 9.17057 13.2689ZM12.0872 13.2689C12.5475 13.2689 12.9206 12.8958 12.9206 12.4355C12.9206 11.9753 12.5475 11.6022 12.0872 11.6022C11.627 11.6022 11.2539 11.9753 11.2539 12.4355C11.2539 12.8958 11.627 13.2689 12.0872 13.2689Z"
    fill="currentColor"
  />
</svg>

<svg
  *ngIf="name === 'ticket-sale'"
  xmlns="http://www.w3.org/2000/svg"
  width="21"
  height="21"
  viewBox="0 0 21 21"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.16642 4.10352H12.5081C15.6586 4.10352 17.2338 4.10352 18.2126 5.07983C18.8865 5.75204 19.0964 6.70634 19.1618 8.26141C19.1747 8.5698 19.1812 8.72399 19.1236 8.82687C19.066 8.92974 18.8361 9.05813 18.3763 9.3149C17.8657 9.60006 17.5205 10.1449 17.5205 10.7702C17.5205 11.3955 17.8657 11.9403 18.3763 12.2255C18.8361 12.4822 19.066 12.6106 19.1236 12.7135C19.1812 12.8164 19.1747 12.9706 19.1618 13.279C19.0964 14.834 18.8865 15.7883 18.2126 16.4605C17.2338 17.4368 15.6586 17.4368 12.5081 17.4368H9.16642C6.01589 17.4368 4.44063 17.4368 3.46189 16.4605C2.788 15.7883 2.5781 14.834 2.51272 13.279C2.49976 12.9706 2.49327 12.8164 2.55086 12.7135C2.60845 12.6106 2.83835 12.4822 3.29814 12.2255C3.80879 11.9403 4.15396 11.3955 4.15396 10.7702C4.15396 10.1449 3.80879 9.60006 3.29814 9.3149C2.83834 9.05813 2.60845 8.92974 2.55086 8.82687C2.49327 8.72399 2.49976 8.5698 2.51272 8.26141C2.5781 6.70634 2.788 5.75204 3.46189 5.07983C4.44063 4.10352 6.01589 4.10352 9.16642 4.10352ZM13.7938 7.82824C14.0385 8.07232 14.0385 8.46805 13.7938 8.71212L8.78131 13.7121C8.53663 13.9562 8.13991 13.9562 7.89523 13.7121C7.65054 13.468 7.65054 13.0723 7.89523 12.8282L12.9077 7.82824C13.1524 7.58416 13.5491 7.58416 13.7938 7.82824ZM12.933 13.6868C13.3944 13.6868 13.7684 13.3138 13.7684 12.8535C13.7684 12.3933 13.3944 12.0202 12.933 12.0202C12.4716 12.0202 12.0976 12.3933 12.0976 12.8535C12.0976 13.3138 12.4716 13.6868 12.933 13.6868ZM8.75598 9.52018C9.21736 9.52018 9.59138 9.14709 9.59138 8.68685C9.59138 8.22661 9.21736 7.85352 8.75598 7.85352C8.29459 7.85352 7.92057 8.22661 7.92057 8.68685C7.92057 9.14709 8.29459 9.52018 8.75598 9.52018Z"
    fill="currentColor"
  />
</svg>

<svg
  *ngIf="name === 'speaker'"
  xmlns="http://www.w3.org/2000/svg"
  width="21"
  height="21"
  viewBox="0 0 21 21"
  fill="none"
>
  <path
    d="M16.6706 7.4362V12.4362C18.0872 12.4362 19.1706 11.3529 19.1706 9.9362C19.1706 8.51953 18.0872 7.4362 16.6706 7.4362ZM10.0039 6.60286H4.17057C3.25391 6.60286 2.50391 7.35286 2.50391 8.26953V11.6029C2.50391 12.5195 3.25391 13.2695 4.17057 13.2695H5.00391V15.7695C5.00391 16.6862 5.75391 17.4362 6.67057 17.4362H8.33724V13.2695H10.0039L13.3372 16.6029H15.0039V3.26953H13.3372L10.0039 6.60286Z"
    fill="currentColor"
  />
</svg>

<svg
  *ngIf="name === 'sort'"
  xmlns="http://www.w3.org/2000/svg"
  width="21"
  height="21"
  viewBox="0 0 21 21"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3.72429 17.8818C4.94468 19.1022 6.90887 19.1022 10.8372 19.1022C14.7656 19.1022 16.7298 19.1022 17.9502 17.8818C19.1706 16.6614 19.1706 14.6973 19.1706 10.7689C19.1706 6.84051 19.1706 4.87632 17.9502 3.65594C16.7298 2.43555 14.7656 2.43555 10.8372 2.43555C6.90887 2.43555 4.94468 2.43555 3.72429 3.65594C2.50391 4.87632 2.50391 6.84051 2.50391 10.7689C2.50391 14.6973 2.50391 16.6614 3.72429 17.8818ZM13.1289 14.1022C13.1289 14.4474 12.8491 14.7272 12.5039 14.7272H9.17057C8.8254 14.7272 8.54557 14.4474 8.54557 14.1022C8.54557 13.757 8.8254 13.4772 9.17057 13.4772H12.5039C12.8491 13.4772 13.1289 13.757 13.1289 14.1022ZM14.1706 11.3939C14.5158 11.3939 14.7956 11.1141 14.7956 10.7689C14.7956 10.4237 14.5158 10.1439 14.1706 10.1439H7.50391C7.15873 10.1439 6.87891 10.4237 6.87891 10.7689C6.87891 11.1141 7.15873 11.3939 7.50391 11.3939H14.1706ZM16.4622 7.43555C16.4622 7.78073 16.1824 8.06055 15.8372 8.06055H5.83724C5.49206 8.06055 5.21224 7.78073 5.21224 7.43555C5.21224 7.09037 5.49206 6.81055 5.83724 6.81055H15.8372C16.1824 6.81055 16.4622 7.09037 16.4622 7.43555Z"
    fill="currentColor"
  />
</svg>

<svg
  *ngIf="name === 'dollar'"
  xmlns="http://www.w3.org/2000/svg"
  width="21"
  height="21"
  viewBox="0 0 21 21"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.8372 19.1022C15.4396 19.1022 19.1706 15.3713 19.1706 10.7689C19.1706 6.16651 15.4396 2.43555 10.8372 2.43555C6.23487 2.43555 2.50391 6.16651 2.50391 10.7689C2.50391 15.3713 6.23487 19.1022 10.8372 19.1022ZM11.4622 5.76888C11.4622 5.4237 11.1824 5.14388 10.8372 5.14388C10.4921 5.14388 10.2122 5.4237 10.2122 5.76888V6.03283C8.85355 6.2761 7.71224 7.29689 7.71224 8.68555C7.71224 10.2832 9.22289 11.3939 10.8372 11.3939C11.9843 11.3939 12.7122 12.1487 12.7122 12.8522C12.7122 13.5558 11.9843 14.3105 10.8372 14.3105C9.69017 14.3105 8.96224 13.5558 8.96224 12.8522C8.96224 12.507 8.68242 12.2272 8.33724 12.2272C7.99206 12.2272 7.71224 12.507 7.71224 12.8522C7.71224 14.2409 8.85355 15.2617 10.2122 15.5049V15.7689C10.2122 16.1141 10.4921 16.3939 10.8372 16.3939C11.1824 16.3939 11.4622 16.1141 11.4622 15.7689V15.5049C12.8209 15.2617 13.9622 14.2409 13.9622 12.8522C13.9622 11.2546 12.4516 10.1439 10.8372 10.1439C9.69017 10.1439 8.96224 9.3891 8.96224 8.68555C8.96224 7.98199 9.69017 7.22721 10.8372 7.22721C11.9843 7.22721 12.7122 7.98199 12.7122 8.68555C12.7122 9.03073 12.9921 9.31055 13.3372 9.31055C13.6824 9.31055 13.9622 9.03073 13.9622 8.68555C13.9622 7.29689 12.8209 6.2761 11.4622 6.03283V5.76888Z"
    fill="currentColor"
  />
</svg>

<svg
  *ngIf="name === 'settings'"
  xmlns="http://www.w3.org/2000/svg"
  width="21"
  height="21"
  viewBox="0 0 21 21"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.7349 2.56241C12.4263 2.43555 12.0351 2.43555 11.2526 2.43555C10.4701 2.43555 10.0789 2.43555 9.77026 2.56241C9.35877 2.73157 9.03185 3.05603 8.8614 3.46441C8.7836 3.65083 8.75315 3.86763 8.74123 4.18387C8.72372 4.64861 8.48357 5.07879 8.07774 5.31132C7.67192 5.54385 7.17647 5.53516 6.76218 5.31785C6.48026 5.16996 6.27584 5.08773 6.07426 5.06139C5.63268 5.0037 5.18609 5.12246 4.83273 5.39155C4.56772 5.59336 4.3721 5.92963 3.98086 6.60216C3.58962 7.27469 3.394 7.61095 3.35039 7.93963C3.29226 8.37788 3.41192 8.8211 3.68306 9.17178C3.80682 9.33185 3.98075 9.4664 4.25069 9.63473C4.64753 9.8822 4.90287 10.3038 4.90285 10.7689C4.90282 11.234 4.64749 11.6555 4.25069 11.9029C3.9807 12.0713 3.80675 12.2058 3.68298 12.3659C3.41184 12.7166 3.29218 13.1598 3.35031 13.5981C3.39391 13.9268 3.58953 14.263 3.98077 14.9355C4.37202 15.6081 4.56764 15.9443 4.83265 16.1462C5.18601 16.4152 5.6326 16.534 6.07418 16.4763C6.27575 16.45 6.48015 16.3678 6.76205 16.2199C7.17637 16.0026 7.67185 15.9939 8.0777 16.2264C8.48355 16.459 8.72372 16.8892 8.74123 17.3539C8.75315 17.6702 8.7836 17.8869 8.8614 18.0734C9.03185 18.4817 9.35877 18.8062 9.77026 18.9753C10.0789 19.1022 10.4701 19.1022 11.2526 19.1022C12.0351 19.1022 12.4263 19.1022 12.7349 18.9753C13.1464 18.8062 13.4734 18.4817 13.6438 18.0734C13.7216 17.8869 13.7521 17.6701 13.764 17.3539C13.7815 16.8891 14.0216 16.459 14.4274 16.2264C14.8333 15.9938 15.3288 16.0025 15.7431 16.2198C16.025 16.3677 16.2294 16.4499 16.4309 16.4763C16.8725 16.5339 17.3191 16.4152 17.6725 16.1461C17.9375 15.9443 18.1331 15.608 18.5244 14.9355C18.9156 14.263 19.1112 13.9267 19.1548 13.598C19.213 13.1598 19.0933 12.7166 18.8221 12.3659C18.6984 12.2058 18.5244 12.0712 18.2545 11.9029C17.8577 11.6554 17.6023 11.2339 17.6024 10.7688C17.6024 10.3038 17.8577 9.88228 18.2545 9.63487C18.5245 9.4665 18.6985 9.33193 18.8222 9.17184C19.0934 8.82115 19.213 8.37794 19.1549 7.93969C19.1113 7.61101 18.9157 7.27474 18.5244 6.60221C18.1332 5.92969 17.9376 5.59342 17.6726 5.3916C17.3192 5.12251 16.8726 5.00376 16.431 5.06145C16.2295 5.08779 16.0251 5.17001 15.7432 5.31788C15.3288 5.53521 14.8334 5.5439 14.4275 5.31135C14.0217 5.0788 13.7815 4.6486 13.764 4.18383C13.7521 3.86761 13.7216 3.65082 13.6438 3.46441C13.4734 3.05603 13.1464 2.73157 12.7349 2.56241ZM11.2526 13.2689C12.6438 13.2689 13.7716 12.1496 13.7716 10.7689C13.7716 9.38817 12.6438 8.26888 11.2526 8.26888C9.86138 8.26888 8.73357 9.38817 8.73357 10.7689C8.73357 12.1496 9.86138 13.2689 11.2526 13.2689Z"
    fill="currentColor"
  />
</svg>

<svg
  *ngIf="name === 'document'"
  xmlns="http://www.w3.org/2000/svg"
  width="21"
  height="21"
  viewBox="0 0 21 21"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4.16797 4.93669V16.6034C4.16797 17.9841 5.28726 19.1034 6.66797 19.1034H15.0013C16.382 19.1034 17.5013 17.9841 17.5013 16.6034V8.27002C17.5013 6.88931 16.382 5.77002 15.0013 5.77002H5.0013C4.54106 5.77002 4.16797 5.39692 4.16797 4.93669ZM6.8763 10.77C6.8763 10.4248 7.15612 10.145 7.5013 10.145H14.168C14.5131 10.145 14.793 10.4248 14.793 10.77C14.793 11.1152 14.5131 11.395 14.168 11.395H7.5013C7.15612 11.395 6.8763 11.1152 6.8763 10.77ZM6.8763 13.6867C6.8763 13.3415 7.15612 13.0617 7.5013 13.0617H12.0846C12.4298 13.0617 12.7096 13.3415 12.7096 13.6867C12.7096 14.0319 12.4298 14.3117 12.0846 14.3117H7.5013C7.15612 14.3117 6.8763 14.0319 6.8763 13.6867Z"
    fill="currentColor"
  />
  <path
    d="M4.50862 4.17593C4.79902 4.30617 5.0013 4.59781 5.0013 4.93669H15.0013C15.2891 4.93669 15.5683 4.97315 15.8346 5.0417V4.35839C15.8346 3.34414 14.9363 2.56503 13.9323 2.70847L4.9343 3.99389C4.7739 4.01681 4.62856 4.08147 4.50862 4.17593Z"
    fill="currentColor"
  />
</svg>

<svg
  *ngIf="name === 'chevron-right'"
  width="20"
  height="20"
  viewBox="0 0 25 25"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g id="download">
    <path
      id="Icon"
      d="M21.3359 15.7695V19.7695C21.3359 20.3 21.1252 20.8087 20.7502 21.1837C20.3751 21.5588 19.8664 21.7695 19.3359 21.7695H5.33594C4.8055 21.7695 4.2968 21.5588 3.92172 21.1837C3.54665 20.8087 3.33594 20.3 3.33594 19.7695V15.7695M7.33594 10.7695L12.3359 15.7695M12.3359 15.7695L17.3359 10.7695M12.3359 15.7695V3.76953"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
</svg>

<svg
  *ngIf="name === 'close'"
  xmlns="http://www.w3.org/2000/svg"
  width="25"
  height="24"
  viewBox="0 0 25 24"
  fill="none"
>
  <path
    d="M18.4062 6L6.40625 18M6.40625 6L18.4062 18"
    stroke="#101828"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

<svg
  *ngIf="name === 'trash'"
  xmlns="http://www.w3.org/2000/svg"
  width="65"
  height="65"
  viewBox="0 0 65 65"
  fill="none"
>
  <path
    d="M25.1113 11.3607C26.2096 8.2535 29.1729 6.02734 32.6561 6.02734C36.1394 6.02734 39.1027 8.2535 40.2009 11.3607"
    stroke="currentColor"
    stroke-width="4"
    stroke-linecap="round"
  />
  <path
    d="M55.3238 16.6934H9.99023"
    stroke="currentColor"
    stroke-width="4"
    stroke-linecap="round"
  />
  <path
    d="M50.878 23.3594L49.6515 41.757C49.1795 48.8368 48.9436 52.3767 46.6369 54.5347C44.3302 56.6927 40.7824 56.6927 33.687 56.6927H31.6247C24.5292 56.6927 20.9815 56.6927 18.6748 54.5347C16.3681 52.3767 16.1321 48.8368 15.6601 41.757L14.4336 23.3594"
    stroke="currentColor"
    stroke-width="4"
    stroke-linecap="round"
  />
  <path
    d="M25.9902 30.0273L27.3236 43.3607"
    stroke="currentColor"
    stroke-width="4"
    stroke-linecap="round"
  />
  <path
    d="M39.3236 30.0273L37.9902 43.3607"
    stroke="currentColor"
    stroke-width="4"
    stroke-linecap="round"
  />
</svg>

<svg
  *ngIf="name === 'upload'"
  xmlns="http://www.w3.org/2000/svg"
  width="13"
  height="13"
  viewBox="0 0 13 13"
  fill="none"
>
  <path
    d="M10.6562 8.16992V10.1699C10.6562 10.4351 10.5509 10.6895 10.3634 10.877C10.1758 11.0646 9.92147 11.1699 9.65625 11.1699H2.65625C2.39103 11.1699 2.13668 11.0646 1.94914 10.877C1.76161 10.6895 1.65625 10.4351 1.65625 10.1699V8.16992M8.65625 4.66992L6.15625 2.16992M6.15625 2.16992L3.65625 4.66992M6.15625 2.16992V8.16992"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

<svg
  *ngIf="name === 'map'"
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="21"
  viewBox="0 0 20 21"
  fill="none"
>
  <path
    d="M2.02957 5.0952C1.66602 5.50903 1.66602 6.21855 1.66602 7.63759V15.4653C1.66602 16.4703 1.66602 16.9728 1.92818 17.3511C2.19034 17.7294 2.64869 17.8883 3.56538 18.2061L4.64387 18.58C5.22799 18.7825 5.67744 18.9383 6.05462 19.0387C6.30069 19.1041 6.52713 18.911 6.52713 18.6564V6.03124C6.52713 5.8238 6.37405 5.64874 6.17299 5.59774C5.84863 5.51547 5.45874 5.3803 4.92436 5.19504C3.62999 4.74629 2.9828 4.52192 2.49036 4.74977C2.31553 4.83067 2.15865 4.94827 2.02957 5.0952Z"
    fill="currentColor"
  />
  <path
    d="M10.5163 3.70695L9.23636 4.59445C8.7733 4.91552 8.43395 5.15082 8.14414 5.31858C8.0068 5.39808 7.91602 5.54191 7.91602 5.7006V18.2397C7.91602 18.5485 8.236 18.7414 8.49615 18.5749C8.77537 18.3963 9.0951 18.1746 9.48236 17.9061L10.7623 17.0186C11.2254 16.6976 11.5648 16.4622 11.8546 16.2945C11.9919 16.215 12.0827 16.0711 12.0827 15.9125V3.37335C12.0827 3.06452 11.7627 2.8717 11.5025 3.03812C11.2233 3.21674 10.9036 3.43843 10.5163 3.70695Z"
    fill="currentColor"
  />
  <path
    d="M16.4333 3.40693L15.3548 3.03303C14.7707 2.83051 14.3213 2.67472 13.9441 2.57438C13.698 2.50893 13.4716 2.70207 13.4716 2.95669V15.5818C13.4716 15.7893 13.6246 15.9643 13.8257 16.0153C14.1501 16.0976 14.54 16.2328 15.0743 16.418C16.3687 16.8668 17.0159 17.0911 17.5083 16.8633C17.6832 16.7824 17.8401 16.6648 17.9691 16.5179C18.3327 16.104 18.3327 15.3945 18.3327 13.9755V6.14772C18.3327 5.14274 18.3327 4.64024 18.0705 4.26194C17.8084 3.88364 17.35 3.72473 16.4333 3.40693Z"
    fill="currentColor"
  />
</svg>

<svg
  *ngIf="name === 'pie-chart-2'"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <path
    d="M6.22209 4.60105C6.66665 4.304 7.13344 4.04636 7.6171 3.82976C8.98898 3.21539 9.67491 2.9082 10.5875 3.4994C11.5 4.09061 11.5 5.06041 11.5 7.00001V8.50001C11.5 10.3856 11.5 11.3284 12.0858 11.9142C12.6716 12.5 13.6144 12.5 15.5 12.5H17C18.9396 12.5 19.9094 12.5 20.5006 13.4125C21.0918 14.3251 20.7846 15.011 20.1702 16.3829C19.9536 16.8666 19.696 17.3334 19.399 17.7779C18.3551 19.3402 16.8714 20.5578 15.1355 21.2769C13.3996 21.9959 11.4895 22.184 9.64665 21.8175C7.80383 21.4509 6.11109 20.5461 4.78249 19.2175C3.45389 17.8889 2.5491 16.1962 2.18254 14.3534C1.81598 12.5105 2.00412 10.6004 2.72315 8.86451C3.44218 7.12861 4.65982 5.64492 6.22209 4.60105Z"
    fill="currentColor"
  />
  <path
    d="M21.446 7.06901C20.6342 5.00831 18.9917 3.36579 16.931 2.55398C15.3895 1.94669 14 3.34316 14 5.00002V9.00002C14 9.5523 14.4477 10 15 10H19C20.6569 10 22.0533 8.61055 21.446 7.06901Z"
    fill="currentColor"
  />
</svg>

<svg
  *ngIf="name === 'keyword'"
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="21"
  viewBox="0 0 20 21"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2.88738 3.38836C1.66699 4.60875 1.66699 6.57293 1.66699 10.5013C1.66699 14.4297 1.66699 16.3939 2.88738 17.6142C4.10777 18.8346 6.07195 18.8346 10.0003 18.8346C13.9287 18.8346 15.8929 18.8346 17.1133 17.6142C18.3337 16.3939 18.3337 14.4297 18.3337 10.5013C18.3337 6.57293 18.3337 4.60875 17.1133 3.38836C15.8929 2.16797 13.9287 2.16797 10.0003 2.16797C6.07195 2.16797 4.10777 2.16797 2.88738 3.38836ZM8.29363 5.70963C7.93542 5.70958 7.60053 5.70952 7.32693 5.75039C7.01785 5.79657 6.70032 5.90572 6.44651 6.18773C6.20118 6.46032 6.11457 6.78514 6.07703 7.09542C6.04193 7.38544 6.04196 7.74496 6.04199 8.15092L6.04199 8.18649C6.04199 8.53167 6.32181 8.81149 6.66699 8.81149C7.01217 8.81149 7.29199 8.53167 7.29199 8.18649C7.29199 7.73406 7.29307 7.4514 7.31798 7.24557C7.32966 7.14901 7.34427 7.09337 7.35607 7.06148C7.36604 7.03457 7.37315 7.02668 7.37551 7.02406L7.37619 7.02328C7.37733 7.02191 7.37816 7.02091 7.38568 7.01747C7.39953 7.01114 7.43506 6.99811 7.51161 6.98668C7.6817 6.96127 7.92125 6.95964 8.33366 6.95964H9.37533V8.41797C9.37533 8.76315 9.65515 9.04297 10.0003 9.04297C10.3455 9.04297 10.6253 8.76315 10.6253 8.41797V6.95964H11.667C12.0794 6.95964 12.319 6.96127 12.489 6.98668C12.5656 6.99811 12.6011 7.01114 12.615 7.01747C12.6225 7.02091 12.6233 7.02191 12.6245 7.02328L12.625 7.02394C12.6274 7.02656 12.6346 7.03458 12.6446 7.06148C12.6564 7.09337 12.671 7.14901 12.6827 7.24557C12.7076 7.4514 12.7087 7.73406 12.7087 8.18649C12.7087 8.53167 12.9885 8.81149 13.3337 8.81149C13.6788 8.81149 13.9587 8.53167 13.9587 8.18649L13.9587 8.15091C13.9587 7.74495 13.9587 7.38543 13.9236 7.09542C13.8861 6.78514 13.7995 6.46032 13.5541 6.18773C13.3003 5.90572 12.9828 5.79657 12.6737 5.75039C12.4001 5.70952 12.0652 5.70958 11.707 5.70963H8.29363ZM6.66699 9.8763C6.32181 9.8763 6.04199 10.1561 6.04199 10.5013C6.04199 10.8465 6.32181 11.1263 6.66699 11.1263H13.3337C13.6788 11.1263 13.9587 10.8465 13.9587 10.5013C13.9587 10.1561 13.6788 9.8763 13.3337 9.8763H6.66699ZM10.6253 12.5846C10.6253 12.2395 10.3455 11.9596 10.0003 11.9596C9.65515 11.9596 9.37533 12.2395 9.37533 12.5846V14.043H7.91699C7.57181 14.043 7.29199 14.3228 7.29199 14.668C7.29199 15.0131 7.57181 15.293 7.91699 15.293H12.0837C12.4288 15.293 12.7087 15.0131 12.7087 14.668C12.7087 14.3228 12.4288 14.043 12.0837 14.043H10.6253V12.5846Z"
    fill="currentColor"
  />
</svg>

<svg
  *ngIf="name === 'bell'"
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g id="Bold / Notifications / Bell ">
    <g id="Vector">
      <path
        d="M6.95983 16.868C7.66073 17.759 8.76182 18.3332 10 18.3332C11.2382 18.3332 12.3393 17.759 13.0402 16.868C11.022 17.1415 8.97798 17.1415 6.95983 16.868Z"
        fill="currentColor"
      />
      <path
        d="M15.6243 7.49984V8.08659C15.6243 8.79075 15.8252 9.47915 16.2018 10.065L17.1247 11.5008C17.9676 12.8122 17.3241 14.5948 15.858 15.0095C12.0227 16.0943 7.97728 16.0943 4.14197 15.0095C2.67587 14.5948 2.03235 12.8122 2.8753 11.5008L3.79816 10.065C4.17476 9.47915 4.37573 8.79075 4.37573 8.08659V7.49984C4.37573 4.27818 6.8938 1.6665 10 1.6665C13.1062 1.6665 15.6243 4.27818 15.6243 7.49984Z"
        fill="currentColor"
      />
    </g>
  </g>
</svg>

<svg
  *ngIf="name === 'refresh'"
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M8.06 10.78C7.67333 10.7933 7.30347 10.7301 6.9504 10.5904C6.59733 10.4507 6.2872 10.2472 6.02 9.98C5.75333 9.71333 5.54987 9.41333 5.4096 9.08C5.26933 8.74667 5.19947 8.39333 5.2 8.02C5.2 7.88667 5.20667 7.75653 5.22 7.6296C5.23333 7.50267 5.26 7.37947 5.3 7.26C5.35333 7.1 5.35013 6.94 5.2904 6.78C5.23067 6.62 5.1272 6.50667 4.98 6.44C4.82 6.37333 4.66347 6.37333 4.5104 6.44C4.35733 6.50667 4.25387 6.62 4.2 6.78C4.13333 6.98 4.08347 7.18 4.0504 7.38C4.01733 7.58 4.00053 7.78667 4 8C4 8.53333 4.10347 9.04347 4.3104 9.5304C4.51733 10.0173 4.8072 10.4472 5.18 10.82C5.54 11.1933 5.96347 11.48 6.4504 11.68C6.93733 11.88 7.44053 11.9867 7.96 12L7.62 12.34C7.5 12.46 7.44 12.6 7.44 12.76C7.44 12.92 7.5 13.06 7.62 13.18C7.74 13.3 7.88 13.36 8.04 13.36C8.2 13.36 8.34 13.3 8.46 13.18L9.74 11.9C9.9 11.74 9.98 11.5533 9.98 11.34C9.98 11.1267 9.9 10.94 9.74 10.78L8.46 9.5C8.34 9.38 8.2 9.32 8.04 9.32C7.88 9.32 7.74 9.38 7.62 9.5C7.5 9.62 7.44 9.76 7.44 9.92C7.44 10.08 7.5 10.22 7.62 10.34L8.06 10.78ZM7.92 5.2C8.30667 5.2 8.68 5.27013 9.04 5.4104C9.4 5.55067 9.71333 5.75387 9.98 6.02C10.2467 6.28667 10.4501 6.58667 10.5904 6.92C10.7307 7.25333 10.8005 7.60667 10.8 7.98C10.8 8.11333 10.7933 8.2432 10.78 8.3696C10.7667 8.496 10.74 8.61947 10.7 8.74C10.6467 8.9 10.6501 9.0632 10.7104 9.2296C10.7707 9.396 10.8739 9.5128 11.02 9.58C11.18 9.64667 11.3368 9.64667 11.4904 9.58C11.644 9.51333 11.7472 9.4 11.8 9.24C11.8667 9.04 11.9168 8.83653 11.9504 8.6296C11.984 8.42267 12.0005 8.2128 12 8C12 7.46667 11.9032 6.9568 11.7096 6.4704C11.516 5.984 11.2261 5.5472 10.84 5.16C10.4667 4.78667 10.0368 4.50347 9.5504 4.3104C9.064 4.11733 8.56053 4.02053 8.04 4.02L8.4 3.66C8.50667 3.54 8.56 3.4 8.56 3.24C8.56 3.08 8.5 2.94 8.38 2.82C8.26 2.7 8.12 2.64 7.96 2.64C7.8 2.64 7.66 2.7 7.54 2.82L6.26 4.1C6.1 4.26 6.02 4.44667 6.02 4.66C6.02 4.87333 6.1 5.06 6.26 5.22L7.54 6.5C7.66 6.62 7.8 6.68 7.96 6.68C8.12 6.68 8.26 6.62 8.38 6.5C8.5 6.38 8.56 6.24 8.56 6.08C8.56 5.92 8.5 5.78 8.38 5.66L7.92 5.2ZM8 16C6.89333 16 5.85333 15.7899 4.88 15.3696C3.90667 14.9493 3.06 14.3795 2.34 13.66C1.62 12.94 1.05013 12.0933 0.6304 11.12C0.210667 10.1467 0.000533333 9.10667 0 8C0 6.89333 0.210133 5.85333 0.6304 4.88C1.05067 3.90667 1.62053 3.06 2.34 2.34C3.06 1.62 3.90667 1.05013 4.88 0.6304C5.85333 0.210667 6.89333 0.000533333 8 0C9.10667 0 10.1467 0.210133 11.12 0.6304C12.0933 1.05067 12.94 1.62053 13.66 2.34C14.38 3.06 14.9501 3.90667 15.3704 4.88C15.7907 5.85333 16.0005 6.89333 16 8C16 9.10667 15.7899 10.1467 15.3696 11.12C14.9493 12.0933 14.3795 12.94 13.66 13.66C12.94 14.38 12.0933 14.9501 11.12 15.3704C10.1467 15.7907 9.10667 16.0005 8 16ZM8 14.4C9.78667 14.4 11.3 13.78 12.54 12.54C13.78 11.3 14.4 9.78667 14.4 8C14.4 6.21333 13.78 4.7 12.54 3.46C11.3 2.22 9.78667 1.6 8 1.6C6.21333 1.6 4.7 2.22 3.46 3.46C2.22 4.7 1.6 6.21333 1.6 8C1.6 9.78667 2.22 11.3 3.46 12.54C4.7 13.78 6.21333 14.4 8 14.4Z"
    fill="currentColor"
  />
</svg>

<svg
  *ngIf="name === 'lock'"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  version="1.1"
  width="16"
  height="16"
  viewBox="0 0 36 36"
  preserveAspectRatio="xMidYMid meet"
>
  <path
    d="M26,15V10.72a8.2,8.2,0,0,0-8-8.36,8.2,8.2,0,0,0-8,8.36V15H7V32a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V15ZM19,25.23V28H17V25.14a2.4,2.4,0,1,1,2,.09ZM24,15H12V10.72a6.2,6.2,0,0,1,6-6.36,6.2,6.2,0,0,1,6,6.36Z"
  />
  <rect x="0" y="0" width="36" height="36" fill-opacity="0" />
</svg>

<svg
  *ngIf="name === 'download'"
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5M5.83333 8.33333L10 12.5M10 12.5L14.1667 8.33333M10 12.5V2.5"
    stroke="currentColor"
    stroke-width="1.67"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

<svg
  *ngIf="name === 'history'"
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4.23224 4.22422C7.39501 1.0659 12.5364 1.09948 15.7185 4.2816C18.902 7.46509 18.9342 12.6095 15.7718 15.772C12.6094 18.9344 7.46494 18.9021 4.28145 15.7187C2.39491 13.8321 1.61587 11.2584 1.95039 8.81781C1.99727 8.47583 2.3125 8.2366 2.65448 8.28347C2.99646 8.33035 3.23569 8.64558 3.18881 8.98756C2.9055 11.0545 3.56485 13.2343 5.16533 14.8348C7.86906 17.5385 12.222 17.554 14.8879 14.8881C17.5538 12.2221 17.5383 7.86922 14.8346 5.16549C12.1323 2.46313 7.78241 2.44628 5.11612 5.1081L5.73921 5.11123C6.08438 5.11296 6.36279 5.39419 6.36106 5.73936C6.35932 6.08454 6.0781 6.36295 5.73293 6.36121L3.61163 6.35055C3.26891 6.34883 2.9915 6.07142 2.98978 5.7287L2.97912 3.60741C2.97739 3.26223 3.2558 2.98101 3.60097 2.97928C3.94615 2.97754 4.22737 3.25595 4.22911 3.60113L4.23224 4.22422ZM9.9999 6.04172C10.3451 6.04172 10.6249 6.32154 10.6249 6.66672V9.74117L12.5252 11.6414C12.7693 11.8855 12.7693 12.2813 12.5252 12.5253C12.2811 12.7694 11.8854 12.7694 11.6413 12.5253L9.3749 10.2589V6.66672C9.3749 6.32154 9.65472 6.04172 9.9999 6.04172Z"
    fill="currentColor"
  />
</svg>

<svg
  *ngIf="name === 'check'"
  xmlns="http://www.w3.org/2000/svg"
  width="22"
  height="22"
  viewBox="0 0 22 22"
  fill="none"
>
  <path
    d="M4.35938 10.2532L9.28125 15.1751L18.1406 6.3157"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

<svg
  *ngIf="name === 'invest'"
  width="21"
  height="11"
  viewBox="0 0 21 11"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M12.5529 5.13881C13.6271 4.33598 14.6547 3.56689 15.6832 2.79743C16.5636 2.14041 17.444 1.4844 18.3244 0.829407C18.6124 0.616003 18.9598 0.550049 19.3514 0.636093C19.743 0.722137 19.9762 0.929476 20.0625 1.22248C20.1458 1.50752 20.0001 1.7414 19.7329 1.94267C18.5118 2.8534 17.2918 3.76438 16.0728 4.67561C15.169 5.34981 14.2646 6.02363 13.3594 6.69708C12.8632 7.06475 12.2887 7.06665 11.7945 6.70276C11.1078 6.19736 10.4257 5.68818 9.74809 5.1752C9.6714 5.11758 9.62314 5.03912 9.5688 4.97847L3.86175 9.24125C3.94302 9.24504 4.02124 9.25148 4.09997 9.25186C4.76027 9.25186 5.42057 9.24694 6.08088 9.2549C6.51718 9.25982 6.84581 9.41789 7.02511 9.71392C7.19628 9.99669 7.13939 10.2711 6.87273 10.5122C6.77707 10.6015 6.65519 10.6733 6.51649 10.7219C6.37779 10.7706 6.22597 10.7948 6.07275 10.7927C4.49209 10.7953 2.90736 10.7976 1.32467 10.7916C0.726839 10.7893 0.284435 10.4504 0.282404 10.005C0.277325 8.82998 0.277325 7.65493 0.282404 6.47988C0.282405 6.03336 0.751219 5.68388 1.31908 5.68767C1.88694 5.69146 2.32477 6.02502 2.33493 6.47268C2.34458 6.95255 2.33747 7.43281 2.33747 7.91306L2.33747 8.11206L2.42991 8.15679C2.48739 8.08924 2.55157 8.025 2.62191 7.96461C4.64277 6.45373 6.66516 4.94398 8.68907 3.43536C9.21579 3.04305 9.78517 3.04229 10.3099 3.43195C10.9989 3.94392 11.6868 4.45753 12.3736 4.97279C12.4325 5.01713 12.4797 5.07172 12.5529 5.13881Z"
    fill="currentColor"
  />
</svg>

<svg
  *ngIf="name === 'user-check'"
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M12.5 5.00033C12.5 6.84127 11.0076 8.33366 9.16667 8.33366C7.32572 8.33366 5.83333 6.84127 5.83333 5.00033C5.83333 3.15938 7.32572 1.66699 9.16667 1.66699C11.0076 1.66699 12.5 3.15938 12.5 5.00033Z"
    fill="currentColor"
  />
  <path
    d="M15.8333 14.5837C15.8333 16.6547 15.8333 18.3337 9.16667 18.3337C2.5 18.3337 2.5 16.6547 2.5 14.5837C2.5 12.5126 5.48477 10.8337 9.16667 10.8337C12.8486 10.8337 15.8333 12.5126 15.8333 14.5837Z"
    fill="currentColor"
  />
  <path
    d="M17.9671 7.49889C18.1965 7.2409 18.1732 6.84585 17.9152 6.61653C17.6572 6.3872 17.2622 6.41044 17.0329 6.66843L15.2284 8.69841L14.5848 8.1191C14.3282 7.88819 13.933 7.90899 13.7021 8.16556C13.4712 8.42213 13.492 8.81731 13.7486 9.04822L14.8597 10.0482C14.9834 10.1596 15.1464 10.217 15.3126 10.2077C15.4787 10.1984 15.6343 10.1233 15.7449 9.99889L17.9671 7.49889Z"
    fill="currentColor"
  />
</svg>

<svg
  *ngIf="name === 'gps'"
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M1.66797 10.0003C1.66797 10.3214 1.92827 10.5817 2.24936 10.5817H3.82665C4.10195 13.5427 6.45892 15.8997 9.41991 16.175V17.7523C9.41991 18.0734 9.68021 18.3337 10.0013 18.3337C10.3224 18.3337 10.5827 18.0734 10.5827 17.7523V16.175C13.5437 15.8997 15.9007 13.5427 16.176 10.5817H17.7532C18.0743 10.5817 18.3346 10.3214 18.3346 10.0003C18.3346 9.67923 18.0743 9.41893 17.7532 9.41893H16.176C15.9007 6.45794 13.5437 4.10097 10.5827 3.82567V2.24839C10.5827 1.92729 10.3224 1.66699 10.0013 1.66699C9.68021 1.66699 9.41991 1.92729 9.41991 2.24839V3.82567C6.45892 4.10097 4.10195 6.45794 3.82665 9.41893H2.24936C1.92827 9.41893 1.66797 9.67923 1.66797 10.0003ZM7.09433 10.0003C7.09433 8.39485 8.39582 7.09335 10.0013 7.09335C11.6068 7.09335 12.9083 8.39485 12.9083 10.0003C12.9083 11.6058 11.6068 12.9073 10.0013 12.9073C8.39582 12.9073 7.09433 11.6058 7.09433 10.0003Z"
    fill="currentColor"
  />
  <path
    d="M8.25712 10.0003C8.25712 9.03704 9.03802 8.25614 10.0013 8.25614C10.9646 8.25614 11.7455 9.03704 11.7455 10.0003C11.7455 10.9636 10.9646 11.7445 10.0013 11.7445C9.03802 11.7445 8.25712 10.9636 8.25712 10.0003Z"
    fill="currentColor"
  />
</svg>

<svg
  *ngIf="name === 'hotel'"
  fill="currentColor"
  version="1.1"
  id="Capa_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  width="20"
  height="20"
  viewBox="0 0 564.76 564.76"
  xml:space="preserve"
>
  <g>
    <g>
      <path
        d="M458.149,72.602h-83.415v35.153v12.497c0,12.485-4.676,23.751-13.52,32.589c-8.844,8.843-20.116,13.519-32.589,13.519
			h-92.498c-12.472,0-23.739-4.676-32.583-13.513c-8.85-8.844-13.525-20.11-13.525-32.595v-12.497V72.602h-83.416
			c-4.761,0-8.886,1.738-12.362,5.214c-3.477,3.488-5.221,7.607-5.221,12.356v457.011c0,4.754,1.738,8.879,5.221,12.355
			c3.476,3.477,7.595,5.221,12.362,5.221h117.437c-0.428-2.02-0.691-4.1-0.691-6.285V529.6v-51.162
			c0-7.98,2.907-14.896,8.758-20.754c5.838-5.82,12.754-8.752,20.753-8.752h59.027c7.986,0,14.902,2.939,20.753,8.752
			c5.838,5.857,8.764,12.773,8.764,20.754V529.6v28.875c0,2.186-0.257,4.266-0.691,6.285h117.442c4.756,0,8.881-1.744,12.362-5.221
			c3.477-3.482,5.221-7.602,5.221-12.355V90.172c0-4.755-1.744-8.874-5.221-12.356C467.029,74.34,462.911,72.602,458.149,72.602z
			 M428.511,404.58c-2.112,2.113-4.608,3.164-7.497,3.164h-21.328c-2.889,0-5.393-1.051-7.504-3.164
			c-2.111-2.111-3.164-4.607-3.164-7.496v-21.328c0-2.883,1.053-5.385,3.164-7.496c2.111-2.105,4.608-3.172,7.504-3.172h21.328
			c2.889,0,5.385,1.066,7.497,3.172c2.111,2.117,3.17,4.613,3.17,7.496v21.328C431.681,399.973,430.622,402.477,428.511,404.58z
			 M431.681,461.068v21.328c0,2.895-1.059,5.398-3.17,7.498c-2.112,2.117-4.608,3.164-7.497,3.164h-21.328
			c-2.889,0-5.393-1.047-7.504-3.164c-2.111-2.105-3.164-4.604-3.164-7.498v-21.328c0-2.883,1.053-5.385,3.164-7.496
			c2.111-2.105,4.608-3.164,7.504-3.164h21.328c2.889,0,5.385,1.059,7.497,3.164C430.622,455.689,431.681,458.186,431.681,461.068z
			 M428.511,319.262c-2.112,2.117-4.608,3.17-7.497,3.17h-21.328c-2.889,0-5.393-1.053-7.504-3.17
			c-2.111-2.105-3.164-4.602-3.164-7.496v-21.322c0-2.889,1.053-5.393,3.164-7.498c2.111-2.111,4.608-3.169,7.504-3.169h21.328
			c2.889,0,5.385,1.059,7.497,3.169c2.111,2.111,3.17,4.609,3.17,7.498v21.322C431.681,314.66,430.622,317.162,428.511,319.262z
			 M428.511,233.949c-2.112,2.118-4.608,3.17-7.497,3.17h-21.328c-2.889,0-5.393-1.053-7.504-3.17
			c-2.111-2.105-3.164-4.602-3.164-7.497v-21.328c0-2.882,1.053-5.386,3.164-7.497c2.111-2.105,4.608-3.164,7.504-3.164h21.328
			c2.889,0,5.385,1.059,7.497,3.164c2.111,2.118,3.17,4.615,3.17,7.497v21.328C431.681,229.347,430.622,231.85,428.511,233.949z
			 M428.511,148.636c-2.112,2.118-4.608,3.164-7.497,3.164h-21.328c-2.889,0-5.393-1.046-7.504-3.164
			c-2.111-2.105-3.164-4.602-3.164-7.497v-21.329c0-2.882,1.053-5.385,3.164-7.497c2.111-2.105,4.608-3.164,7.504-3.164h21.328
			c2.889,0,5.385,1.059,7.497,3.164c2.111,2.117,3.17,4.614,3.17,7.497v21.329C431.681,144.034,430.622,146.537,428.511,148.636z
			 M303.705,205.124c0-2.882,1.053-5.386,3.164-7.497c2.111-2.105,4.608-3.164,7.497-3.164h21.328c2.883,0,5.38,1.059,7.497,3.164
			c2.111,2.118,3.164,4.615,3.164,7.497v21.328c0,2.895-1.053,5.398-3.164,7.497c-2.117,2.118-4.614,3.17-7.497,3.17h-21.328
			c-2.889,0-5.386-1.053-7.497-3.17c-2.111-2.105-3.164-4.602-3.164-7.497V205.124z M303.705,290.443
			c0-2.889,1.053-5.393,3.164-7.498c2.111-2.111,4.608-3.169,7.497-3.169h21.328c2.883,0,5.38,1.059,7.497,3.169
			c2.111,2.111,3.164,4.609,3.164,7.498v21.322c0,2.895-1.053,5.396-3.164,7.496c-2.117,2.117-4.614,3.17-7.497,3.17h-21.328
			c-2.889,0-5.386-1.053-7.497-3.17c-2.111-2.105-3.164-4.602-3.164-7.496V290.443z M172.572,404.58
			c-2.117,2.113-4.614,3.164-7.503,3.164h-21.328c-2.889,0-5.392-1.051-7.497-3.164c-2.118-2.111-3.17-4.607-3.17-7.496v-21.328
			c0-2.883,1.053-5.385,3.17-7.496c2.105-2.105,4.608-3.172,7.497-3.172h21.328c2.889,0,5.386,1.066,7.503,3.172
			c2.105,2.117,3.164,4.613,3.164,7.496v21.328C175.736,399.973,174.677,402.477,172.572,404.58z M175.736,461.068v21.328
			c0,2.895-1.059,5.398-3.164,7.498c-2.117,2.117-4.614,3.164-7.503,3.164h-21.328c-2.889,0-5.392-1.047-7.497-3.164
			c-2.118-2.105-3.17-4.604-3.17-7.498v-21.328c0-2.883,1.053-5.385,3.17-7.496c2.105-2.105,4.608-3.164,7.497-3.164h21.328
			c2.889,0,5.386,1.059,7.503,3.164C174.677,455.689,175.736,458.186,175.736,461.068z M172.572,319.262
			c-2.117,2.117-4.614,3.17-7.503,3.17h-21.328c-2.889,0-5.392-1.053-7.497-3.17c-2.118-2.105-3.17-4.602-3.17-7.496v-21.322
			c0-2.889,1.053-5.393,3.17-7.498c2.105-2.111,4.608-3.169,7.497-3.169h21.328c2.889,0,5.386,1.059,7.503,3.169
			c2.105,2.111,3.164,4.609,3.164,7.498v21.322C175.736,314.66,174.677,317.162,172.572,319.262z M172.572,233.949
			c-2.117,2.118-4.614,3.17-7.503,3.17h-21.328c-2.889,0-5.392-1.053-7.497-3.17c-2.118-2.105-3.17-4.602-3.17-7.497v-21.328
			c0-2.882,1.053-5.386,3.17-7.497c2.105-2.105,4.608-3.164,7.497-3.164h21.328c2.889,0,5.386,1.059,7.503,3.164
			c2.105,2.118,3.164,4.615,3.164,7.497v21.328C175.736,229.347,174.677,231.85,172.572,233.949z M172.572,148.636
			c-2.117,2.118-4.614,3.164-7.503,3.164h-21.328c-2.889,0-5.392-1.046-7.497-3.164c-2.118-2.105-3.17-4.602-3.17-7.497v-21.329
			c0-2.882,1.053-5.385,3.17-7.497c2.105-2.105,4.608-3.164,7.497-3.164h21.328c2.889,0,5.386,1.059,7.503,3.164
			c2.105,2.117,3.164,4.614,3.164,7.497v21.329C175.736,144.034,174.677,146.537,172.572,148.636z M261.049,397.084
			c0,2.889-1.059,5.393-3.164,7.496c-2.118,2.111-4.615,3.164-7.503,3.164h-21.329c-2.889,0-5.385-1.053-7.497-3.164
			c-2.112-2.111-3.164-4.607-3.164-7.496v-21.328c0-2.883,1.052-5.385,3.164-7.498c2.111-2.104,4.608-3.17,7.497-3.17h21.329
			c2.882,0,5.385,1.066,7.503,3.17c2.105,2.119,3.164,4.615,3.164,7.498V397.084z M261.049,311.766c0,2.895-1.059,5.396-3.164,7.496
			c-2.118,2.117-4.615,3.17-7.503,3.17h-21.329c-2.889,0-5.385-1.053-7.497-3.17c-2.112-2.105-3.164-4.602-3.164-7.496v-21.322
			c0-2.889,1.052-5.393,3.164-7.498c2.111-2.111,4.608-3.169,7.497-3.169h21.329c2.882,0,5.385,1.059,7.503,3.169
			c2.105,2.111,3.164,4.609,3.164,7.498V311.766z M261.049,226.452c0,2.895-1.059,5.398-3.164,7.497
			c-2.118,2.118-4.615,3.17-7.503,3.17h-21.329c-2.889,0-5.385-1.053-7.497-3.17c-2.112-2.105-3.164-4.602-3.164-7.497v-21.328
			c0-2.882,1.052-5.386,3.164-7.497c2.111-2.105,4.608-3.164,7.497-3.164h21.329c2.882,0,5.385,1.059,7.503,3.164
			c2.105,2.118,3.164,4.615,3.164,7.497V226.452z M335.7,407.744h-21.328c-2.889,0-5.386-1.051-7.497-3.164
			c-2.111-2.111-3.164-4.607-3.164-7.496v-21.328c0-2.883,1.053-5.385,3.164-7.496c2.111-2.105,4.608-3.172,7.497-3.172H335.7
			c2.883,0,5.38,1.066,7.497,3.172c2.111,2.117,3.164,4.613,3.164,7.496v21.328c0,2.889-1.053,5.393-3.164,7.496
			C341.08,406.691,338.583,407.744,335.7,407.744z"
      />
      <path
        d="M218.417,141.439c5.043,4.29,10.912,6.561,17.711,6.561h22.295h47.919h22.289c6.793,0,12.662-2.271,17.711-6.561
			c0.631-0.533,1.292-0.979,1.897-1.579c5.429-5.428,8.146-11.964,8.146-19.608v-12.497V72.602V27.754
			c0-7.644-2.711-14.18-8.146-19.608C342.812,2.717,336.275,0,328.632,0h-92.504c-7.644,0-14.18,2.717-19.608,8.146
			c-5.428,5.428-8.146,11.964-8.146,19.608v44.847v35.153v12.497c0,7.644,2.711,14.18,8.146,19.608
			C217.125,140.46,217.792,140.901,218.417,141.439z M233.043,72.602V30.833c0-1.665,0.612-3.115,1.83-4.333s2.668-1.83,4.333-1.83
			h12.332c1.671,0,3.115,0.612,4.333,1.83c1.218,1.224,1.83,2.668,1.83,4.333v30.833h49.333V30.833c0-1.665,0.612-3.115,1.83-4.333
			s2.668-1.83,4.333-1.83h12.332c1.671,0,3.115,0.612,4.333,1.83c1.218,1.224,1.829,2.668,1.829,4.333v41.769v35.153v1.396v8.017
			c0,1.671-0.611,3.115-1.829,4.333c-1.225,1.224-2.669,1.83-4.333,1.83h-12.332c-1.671,0-3.115-0.606-4.333-1.83
			c-1.224-1.218-1.83-2.662-1.83-4.333v-5v-4.413v-21.42h-49.321v21.42v4.413v5c0,1.671-0.612,3.115-1.83,4.333
			c-1.224,1.224-2.668,1.83-4.333,1.83h-12.332c-1.671,0-3.115-0.606-4.333-1.83c-1.224-1.218-1.83-2.662-1.83-4.333v-8.017v-1.396
			V72.602H233.043z"
      />
    </g>
  </g>
</svg>

<svg
  *ngIf="name === 'edit'"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M12 20H21M16.5 3.49998C16.8978 3.10216 17.4374 2.87866 18 2.87866C18.2786 2.87866 18.5544 2.93353 18.8118 3.04014C19.0692 3.14674 19.303 3.303 19.5 3.49998C19.697 3.69697 19.8532 3.93082 19.9598 4.18819C20.0665 4.44556 20.1213 4.72141 20.1213 4.99998C20.1213 5.27856 20.0665 5.55441 19.9598 5.81178C19.8532 6.06915 19.697 6.303 19.5 6.49998L7 19L3 20L4 16L16.5 3.49998Z"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

<svg
  *ngIf="name === 'introduction'"
  width="21"
  height="20"
  viewBox="0 0 21 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M1.96094 8.33428V11.6676C1.96094 14.0246 1.96094 15.2031 2.69317 15.9354C2.87429 16.1165 3.0827 16.2528 3.3295 16.3554C3.32391 16.3183 3.31862 16.2812 3.31361 16.244C3.21082 15.4794 3.21087 14.5246 3.21093 13.4165L3.21094 6.66757L3.21093 6.58528C3.21087 5.47717 3.21082 4.5224 3.31361 3.75783C3.31861 3.72064 3.3239 3.68352 3.32949 3.64648C3.08269 3.74908 2.87428 3.8854 2.69317 4.06651C1.96094 4.79874 1.96094 5.97725 1.96094 8.33428Z"
    fill="currentColor"
  />
  <path
    d="M18.6276 8.33428V11.6676C18.6276 14.0246 18.6276 15.2031 17.8954 15.9354C17.7143 16.1165 17.5058 16.2528 17.259 16.3554C17.2646 16.3183 17.2699 16.2812 17.2749 16.244C17.3777 15.4794 17.3777 14.5246 17.3776 13.4165V6.58528C17.3777 5.47717 17.3777 4.5224 17.2749 3.75783C17.2699 3.72064 17.2646 3.68352 17.2591 3.64648C17.5058 3.74908 17.7143 3.8854 17.8954 4.06651C18.6276 4.79874 18.6276 5.97725 18.6276 8.33428Z"
    fill="currentColor"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.19317 2.39825C4.46094 3.13048 4.46094 4.30899 4.46094 6.66602V13.3327C4.46094 15.6897 4.46094 16.8682 5.19317 17.6005C5.9254 18.3327 7.10391 18.3327 9.46094 18.3327H11.1276C13.4846 18.3327 14.6631 18.3327 15.3954 17.6005C16.1276 16.8682 16.1276 15.6897 16.1276 13.3327V6.66602C16.1276 4.30899 16.1276 3.13048 15.3954 2.39825C14.6631 1.66602 13.4846 1.66602 11.1276 1.66602H9.46094C7.10391 1.66602 5.9254 1.66602 5.19317 2.39825ZM7.16927 14.166C7.16927 13.8208 7.44909 13.541 7.79427 13.541H10.2943C10.6394 13.541 10.9193 13.8208 10.9193 14.166C10.9193 14.5112 10.6394 14.791 10.2943 14.791H7.79427C7.44909 14.791 7.16927 14.5112 7.16927 14.166ZM7.79427 10.2077C7.44909 10.2077 7.16927 10.4875 7.16927 10.8327C7.16927 11.1779 7.44909 11.4577 7.79427 11.4577H12.7943C13.1394 11.4577 13.4193 11.1779 13.4193 10.8327C13.4193 10.4875 13.1394 10.2077 12.7943 10.2077H7.79427ZM7.16927 7.49935C7.16927 7.15417 7.44909 6.87435 7.79427 6.87435H12.7943C13.1394 6.87435 13.4193 7.15417 13.4193 7.49935C13.4193 7.84453 13.1394 8.12435 12.7943 8.12435H7.79427C7.44909 8.12435 7.16927 7.84453 7.16927 7.49935Z"
    fill="currentColor"
  />
</svg>

<svg
  *ngIf="name === 'request'"
  class="svg-icon"
  width="24"
  height="24"
  style="vertical-align: middle; fill: currentColor; overflow: hidden"
  viewBox="0 0 1024 1024"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M713.38277661 592.44859619a170.7132019 170.7132019 0 1 0 170.7132019 170.71320191 170.7132019 170.7132019 0 0 0-170.7132019-170.71320191z m3.84104746 191.19878613a58.46927124 58.46927124 0 0 0-31.58194236 8.96244352 58.46927124 58.46927124 0 0 0-26.88732971 50.78717715 21.76593283 21.76593283 0 0 1-21.33915024 21.33915024 21.33915024 21.33915024 0 0 1-21.33915023-21.33915024 102.00113772 102.00113772 0 0 1 42.67830047-85.35660096 73.83345941 73.83345941 0 1 1 60.17640408 23.89984827s-0.85356601 1.70713203-1.70713201 1.70713202z m80.66198748 81.0887709a21.76593283 21.76593283 0 0 1-21.33915024-21.33915022 59.32283725 59.32283725 0 0 0-13.23027274-37.55690443 21.33915024 21.33915024 0 1 1 32.86229097-26.88732889 101.14757172 101.14757172 0 0 1 23.89984826 64.44423332 21.33915024 21.33915024 0 0 1-22.19271625 21.33915022z"
  />
  <path
    d="M713.38277661 559.58630523a213.39150237 213.39150237 0 0 1 64.01745072 10.66957471V172.06733691A85.35660096 85.35660096 0 0 0 692.04362637 90.125H265.26062244a85.35660096 85.35660096 0 0 0-85.35660096 81.94233691v615.84787547a85.35660096 85.35660096 0 0 0 85.35660096 81.94233691h259.91084947A213.39150237 213.39150237 0 0 1 713.38277661 559.58630523zM340.80121386 252.30254181H564.00872494L512.79476519 200.23501523a21.33915024 21.33915024 0 1 1 30.30159293-30.30159375L631.86722311 260.8382019a21.33915024 21.33915024 0 0 1 5.97496207 14.93740476 22.19271625 22.19271625 0 0 1-5.97496207 15.36418817L543.09635812 377.77674522a21.33915024 21.33915024 0 0 1-15.36418817 5.97496205 20.05880081 20.05880081 0 0 1-14.93740475-5.97496205 21.33915024 21.33915024 0 0 1-1e-8-31.58194236L564.00872494 294.98084229H340.80121386a21.33915024 21.33915024 0 0 1-21.33915023-21.33915025 21.33915024 21.33915024 0 0 1 21.33915024-21.33915023zM265.26062244 479.77788294h426.78300393a20.91236682 20.91236682 0 1 1 0 42.67830048H265.26062244a20.91236682 20.91236682 0 1 1 0-42.67830048z m192.05235214 150.65440109H265.26062244a20.48558423 20.48558423 0 0 1-21.33915025-20.48558423 20.91236682 20.91236682 0 0 1 21.33915025-20.48558423h192.05235214a20.91236682 20.91236682 0 0 1 21.33915023 20.48558423 20.48558423 20.48558423 0 0 1-21.33915024 20.48558423z"
  />
</svg>
<svg
  *ngIf="name === 'calendar'"
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.66667 1.875C7.01184 1.875 7.29167 2.15482 7.29167 2.5V3.33333H12.7083V2.5C12.7083 2.15482 12.9882 1.875 13.3333 1.875C13.6785 1.875 13.9583 2.15482 13.9583 2.5V3.33333H14.7917C16.2874 3.33333 17.5 4.54589 17.5 6.04167V15.4167C17.5 16.9124 16.2874 18.125 14.7917 18.125H5.20833C3.71256 18.125 2.5 16.9124 2.5 15.4167V6.04167C2.5 4.54589 3.71256 3.33333 5.20833 3.33333H6.04167V2.5C6.04167 2.15482 6.32149 1.875 6.66667 1.875ZM5.20833 4.58333C4.40292 4.58333 3.75 5.23625 3.75 6.04167V7.08333H16.25V6.04167C16.25 5.23625 15.5971 4.58333 14.7917 4.58333H5.20833ZM16.25 8.33333H3.75V15.4167C3.75 16.2221 4.40292 16.875 5.20833 16.875H14.7917C15.5971 16.875 16.25 16.2221 16.25 15.4167V8.33333Z"
    fill="currentColor"
  />
  <rect x="5.83" y="10" width="1.67" height="1.67" rx="0.42" fill="currentColor" />
  <rect x="9.17" y="10" width="1.67" height="1.67" rx="0.42" fill="currentColor" />
  <rect x="12.5" y="10" width="1.67" height="1.67" rx="0.42" fill="currentColor" />
  <rect x="5.83" y="13.33" width="1.67" height="1.67" rx="0.42" fill="currentColor" />
  <rect x="9.17" y="13.33" width="1.67" height="1.67" rx="0.42" fill="currentColor" />
</svg>
